import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, ModalBody, ModalFooter, ModalHeader } from 'react-bootstrap';

class AlertDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  closeModal(res) {
    let { close } = this.props;
    close(res);
  }

  render() {
    let { modalProps } = this.props;

    return (
      <>
        <ModalHeader toggle={this.closeModal.bind(this, null)}>
          {modalProps.title}
        </ModalHeader>
        <ModalBody>{modalProps.message}</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.closeModal.bind(this)}>
            OK
          </Button>
        </ModalFooter>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {};
};

AlertDialog.propTypes = {
  close: PropTypes.func.isRequired,
  modalProps: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertDialog);
